import SprintRayOrderForm from './index';

export default { SprintRayOrderForm };